import { types } from './mutations';
import getNewspapersCatalogsOccasions from '~/assets/services/newspapersCatalogsOccassion/getNewspapersCatalogsOccasions';

export default {
    async fetchPromotional({ commit }) {
        const newspaperCatalogsOccasions = await getNewspapersCatalogsOccasions();
        commit(types.FETCH_PROMOTIONAL, newspaperCatalogsOccasions);
    },
};
